var PlainAction={newWindowAccessibilityHint:"(opens a new window)"};var _en = {PlainAction:PlainAction};

export { PlainAction, _en as default };
